import {EditBaseCtrl} from "./EditBaseCtrl";
import {AlertingAction} from "../../entities/AlertingAction";
import { StateService, StateParams } from "@uirouter/angularjs";
import {EditAlertingActionModel} from "../../models/edit/EditAlertingActionModel";
import {NotificationService} from "../../services/NotificationService";

export class EditAlertingActionCtrl extends EditBaseCtrl<AlertingAction> {
    public static $inject = ['$scope','$state','$stateParams','EditAlertingActionModel','NotificationService'];
    constructor($scope:any,
                stateService:StateService,
                stateParamsService:StateParams,
                public model:EditAlertingActionModel,
                public notifyService:NotificationService) {
        super($scope,stateService,stateParamsService, notifyService, model);
        $scope.vm = this;
        this.loadData().then((ok)=>{
        });
    }
    pagingRoute(): string {
        return "admin.alertingactions";
    }    
}
